import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { DELETE_BRAND } from "utils/api/graphql/mutations/brand";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Delete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.BRANDS.LIST.path);
  const [deleteBrand] = useMutation(DELETE_BRAND, {
    refetchQueries: [
      {
        query: graphql.queries.BRANDS,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
    ],
    onCompleted: () => {
      setVisible(false);
      navigate(SCREENS.PRIVATE.ADMIN.BRANDS.LIST.path, { replace: true });
    },
  });
  const onSubmit = () => {
    return deleteBrand({
      variables: {
        where: {
          id,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} visible={visible} />;
};

export default Delete;
